import React, {ReactElement, useContext} from 'react';

import {RouterContext} from '../providers/Context.providers';

import Call from './Call';
import Calling from './Calling';
import Dialpad from './Dialpad';
import Login from './Login';
import NotFound from './NotFound';

export enum RouteNames {
	LOGIN = 'LOGIN',
	DIALPAD = 'DIALPAD',
	CALL = 'CALL',
	CALLING = 'CALLING',
	NOT_FOUND = 'NOT_FOUND',
}
export const RouterContainer = (): ReactElement => {
	const router = useContext(RouterContext);
	const ROUTES: {[key: string]: ReactElement} = {
		LOGIN: <Login />,
		DIALPAD: <Dialpad />,
		CALL: <Call />,
		CALLING: <Calling />,
		NOT_FOUND: <NotFound />,
	};

	let child: ReactElement | null = null;
	if (router) {
		child = ROUTES[router?.route];
	}
	return (
		<div>
			{ child }
		</div>
	);
};
